module.exports = __webpack_public_path__ + "static/media/re.17909e37.svg";